import api from "../Component/axios";

export const useSize = () => {
  const getSize = async (id_cultivo) => {
    try {
      const response = await api.get(
        `api/temporada/tamanos?id_cultivo=${id_cultivo}`
      );

      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  return { getSize };
};
